import { VALID_DOMAINS } from "../../firebase/auth";

const state = {
   websites: [
      {
         name: "Fast Forward",
         link: "https://fastforwardhomeloans.com/",
         forms: [
            {
               id: "ffhl-opt-out",
               name: "Opt Out",
               link: "https://fastforwardhomeloans.com/privacy-policy/opt-out"
            },
            {
               id: "ffhl-delete",
               name: "Delete",
               link: "https://fastforwardhomeloans.com/privacy-policy/request-to-delete"
            },
            {
               id: "ffhl-know",
               name: "Know",
               link: "https://fastforwardhomeloans.com/privacy-policy/request-to-know"
            }
         ],
         pages: [
            {
               id: "ffhl-privacy",
               name: "Privacy",
               link: "https://fastforwardhomeloans.com/privacy"
            },
            {
               id: "ffhl-terms",
               name: "Terms of Use",
               link: "https://fastforwardhomeloans.com/terms-of-use"
            },
            {
               id: "ffhl-licenses",
               name: "Licenses",
               link: "https://fastforwardhomeloans.com/licenses"
            }
         ],
      },
      {
         name: "Flat Branch Home Loans",
         link: "https://flatbranchhomeloans.com/",
         forms: [
            {
               id: "fbhl-opt-out",
               name: "Opt Out",
               link: "https://www.flatbranchhomeloans.com/privacy/opt-out"
            },
            {
               id: "fbhl-delete",
               name: "Delete Request",
               link: "https://www.flatbranchhomeloans.com/privacy/request-to-delete"
            },
            {
               id: "fbhl-know",
               name: "Know Request",
               link: "https://www.flatbranchhomeloans.com/privacy/request-to-know"
            }
         ],
         pages: [
            {
               id: "fbhl-privacy",
               name: "Privacy",
               link: "https://www.flatbranchhomeloans.com/privacy"
            },
            {
               id: "fbhl-privacy-notice",
               name: "Privacy Notice",
               link: "https://www.flatbranchhomeloans.com/privacy/consumer-privacy-notice"
            },
            {
               id: "fbhl-online-privacy",
               name: "Online Privacy",
               link: "https://www.flatbranchhomeloans.com/privacy/privacy-policy"
            },
            {
               id: "fbhl-cali-privacy",
               name: "California Privacy",
               link: "https://www.flatbranchhomeloans.com/privacy/california-privacy"
            },
            {
               id: "fbhl-licenses",
               name: "Licenses",
               link: "https://www.flatbranchhomeloans.com/licenses"
            },
            {
               id: "fbhl-terms",
               name: "Terms of Use",
               link: "https://www.flatbranchdev.com/terms-of-use"
            }
         ]
      },
      {
         name: "Flat Branch Servicing",
         link: "https://flatbranchservicing.com/",
         forms: [],
         pages: [
            {
               id: "servicing-privacy",
               name: "Privacy",
               link: "https://www.flatbranchhomeloans.com/privacy-policy"
            },
            {
               id: "servicing-licenses",
               name: "Licenses",
               link: "https://www.flatbranchhomeloans.com/licenses"
            }
         ]
      }
   ],
   contacts: [
      {
         name: "Jim Harralson",
         email: "jharralson@fbhl.com",
         title: "Compliance Manager"
      },
      {
         name: "Brad Chandler",
         email: "bchandler@fbhl.com",
         title: "Web Developer"
      }
   ],
   howTos: [
      {
         id: "help",
         access: "any",
         heading: "Help",
         tips: [
            "For any assistance with the site, contact the Web Developer",
            "To request a change to the website, contact the Web Developer",
            "To report an issue with the website, contact the Web Developer",
            "To add a new user to the website, contact either the Compliance Manager or the Web Developer"
         ]
      },
      {
         id: "requests",
         access: "any",
         heading: "Requests",
         tips: [
            "Click on the Requests drop down to select a request type",
            "User the filters to look up a set of requests or a specific request",
            "Press the Export to CSV button to export the currently viewed requests to excel/csv file",
            "Each request has a status of either Finished, Untouched (no services marked complete), or Unfinished(all services marked complete)",
            "Click a request tile to view the request and change its status",
            "In a request, select any red boxes within the Request Status block to jump to those services",
            "On a service tile click the Status section (anywhere) to update the service status for this request. This will auto-comment the new status.",
            "To add a new service to this request see the Change Services Displayed section and select an available service from the Add Existing Service dropdown.",
            "Requester information cannot be changed."
         ]
      },
      {
         id: "users",
         access: "admin",
         heading: "Users",
         tips: [
            "Click on the Admin drop down to select the Users option",
            "User the filters to look up any users",
            "Click the green New User button to create a new user for the compliance portal",
            "Active users are permitted to log in to the site but will not have permission to see or alter users",
            "Admin users may see, create, update, and delete users",
            `Only <strong>${VALID_DOMAINS.join(", ")}</strong> domains are currently permitted to have access`,
            "Mark a user inactive to revoke their ability to access the portal, this can be undone",
            "Delete a user to permanently revoke their ability to access the portal, this can only be undone by recreating the user",
         ]
      },
      {
         id: "licenses",
         access: "any",
         heading: "Licenses",
         tips: [
            "Click on the Admin drop down to select the Licenses option",
            "Websites where licenses appear are shown",
            "<strong>Changes are immediately reflected on websites</strong>",
            "To change a license for a specific website, select a state from the dropdown for that website and click the green edit button",
            "The text editor may take a second to load the current text, When done editing hit submit or cancel to cancel editing",
            "To delete a license from a specific website, select a state from the dropdown for that website and click the red delete button (confirm your deletion by clicking the green Delete Button)",
            "To create a new license for a specific website, press the green plus button at the bottom right of the website you would like to alter",
            "The text editor may take a second to load, select a state, type in the content you would like to appear and as you would like it to appear, hit submit or cancel",
         ]
      },
      {
         id: "services",
         access: "any",
         heading: "Services",
         tips: [
            "Click on the Admin drop down to select the Services option",
            "Use the filters to search",
            "Press the green New Service button to create a new service for a specific request type",
            "To edit a service click the green Edit button for that service",
            "Inactive services will not be added to incoming requests but are still available to be added to existing requests",
            "To delete a service click the red Delete button",
            "Deleted services will not be added to incoming requests but will not be removed from requests to which they are already assigned",
         ]
      }
   ]
}

const getters = {
   getWebsites(state) {
      return state.websites;
   },
   getContacts(state) {
      return state.contacts;
   },
   getHowTos(state, getters, rootState) {
      if (rootState.user.isAdmin) {
         return state.howTos
      }
      return state.howTos.filter(howTo => {
         return howTo.access !== "admin"
      });
   }
}

const actions = {

}

const mutations = {

}

export default {
   state,
   getters,
   actions,
   mutations
}